import { Component } from '@angular/core';

@Component({
  selector: 'app-version-log',
  templateUrl: './version-log.component.html',
  styleUrl: './version-log.component.scss'
})
export class VersionLogComponent {
  refreshPage() {
    window.location.reload();
  }
}
